export const books = [
  {
    id: 3,
    price: 9.05,
    rating: 5,
    title: "New Placing",
    author: "Sajni Patel",
    reviews: "235",
    image: "the-trouble-with-hating-you.jpg",
    printLength: 352,
    language: "English",
    PublicationDate: "1 June 2019",
    inStock: true,
  },
  {
    id: 5,
    price: 8,
    rating: 4,
    title: "Rich Dad Poor Dad",
    author: "Robert T.Kiyosaki",
    reviews: "8,661",
    image: "rich-dad-poor-dad.jpg",
    printLength: 336,
    language: "English",
    PublicationDate: "27 April 2017",
    inStock: true,
  },
  {
    id: 4,
    price: 16.45,
    rating: 4.5,
    title: "Hopeless",
    author: "Colleen Hoover",
    reviews: "1,587",
    image: "hopeless.jpg",
    printLength: 416,
    language: "English",
    PublicationDate: "8 October 2012",
    inStock: true,
  },
  {
    id: 6,
    price: 21,
    rating: 3.5,
    title: "One True Loves",
    author: "Taylor Jenkins Reid",
    reviews: "2,421",
    image: "one-true-love.jpg",
    printLength: 342,
    language: "English",
    PublicationDate: "17 July 2016",
    inStock: true,
  },
  {
    id: 7,
    price: 11.05,
    rating: 4.5,
    title: "Think And Grow Rich",
    author: "Napolen Hill",
    reviews: "57,521",
    image: "think-and-grow-rich.jpg",
    printLength: 320,
    language: "English",
    PublicationDate: "1 September 2005",
    inStock: true,
  },
  {
    id: 8,
    price: 7.05,
    rating: 4.5,
    title: "Never Split The Difference",
    author: "Chris Voss",
    reviews: "17,980",
    image: "never-split-the-difference.jpg",
    printLength: 288,
    language: "English",
    PublicationDate: "23 March 2017",
    inStock: true,
  },
  {
    id: 2,
    price: 49,
    rating: 5,
    title: "Public Relations Course",
    author: "Colleen Hoover",
    reviews: "3,980",
    image: "confess.jpg",
    printLength: 410,
    language: "English",
    PublicationDate: "1 March 2015",
    inStock: true,
  },
  {
    id: 1,
    price: 10.5,
    rating: 5,
    title: "Atomic Habits:Proven Way To Build Good Habits",
    author: "James Clear",
    reviews: "69,548",
    image: "atomic-habits.jpg",
    printLength: 320,
    language: "English",
    PublicationDate: "16 April 2018",
    inStock: true,
  },
  {
    id: 9,
    price: 12.58,
    rating: 5,
    title: "Good Vibes, Good Life",
    author: "Vex King",
    reviews: "22,252",
    image: "it-ends-with-us.jpg",
    printLength: 325,
    language: "English",
    PublicationDate: "4 December 2018",
    inStock: true,
  },
  {
    id: 10,
    price: 5.98,
    rating: 4.5,
    title: "Beginning Drawing Atelier",
    author: "Juliette Aristides",
    reviews: "661",
    image: "beginning.jpg",
    printLength: 128,
    language: "English",
    PublicationDate: "16 April 2018",
    inStock: false,
  },
];
